import { GetVisitByIdStatusEnum } from 'woofwoof-api';

// The Vetsi assistant (side panel + small-screen tab) is offered for completed visits
// and for confirmed-upcoming visits (CREATED/ACCEPTED). Every other status — live
// (PENDING), oczekuje (PENDING_APPROVAL), and the terminal cancelled/rejected/aborted
// states — never shows it. This is ONLY the status predicate; callers AND it with the
// existing role / same-org / edit-window / viewport gates.
export function isVisitAssistantEligible(status?: string | null): boolean {
  return (
    status === GetVisitByIdStatusEnum.Completed ||
    status === GetVisitByIdStatusEnum.Created ||
    status === GetVisitByIdStatusEnum.Accepted
  );
}
